module.exports = __webpack_public_path__ + "static/kobold-1-aaf05617250c2446e4964df756258d7a.jpg";